import { Observable } from 'rxjs';

import { Injectable, IterableDiffers } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { ITransactionType } from './../../../app/models/transaction-type';
import { IRole } from './../../../app/models/role';
import { App } from './../../../app/state/app.actions';
import { ApplicationState } from './../../../app/state/app.state';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  @Select(ApplicationState.getTransactionTypes)
  tranactionTypes$: Observable<ITransactionType[]>;

  transactionService
  transactionTypes: Array<ITransactionType>;
  roles: Array<IRole>;



  constructor(private store: Store) {
      
      if(!this.transactionTypes) {
        this.store.dispatch(new App.Actions.GetTransactionTypes());
      }

      this.tranactionTypes$.subscribe(types => this.transactionTypes = types);
   }
}
